/* eslint-disable */
export default {
  saveLog: '儲存',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
